var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHealthcareFacilitiesOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.66 11.84L13.08 12.42L12.5 11.84C11.71 11.05 10.43 11.05 9.63999 11.84C8.84999 12.63 8.84999 13.91 9.63999 14.7L12.35 17.41C12.75 17.81 13.4 17.81 13.81 17.41L16.52 14.7C17.31 13.91 17.31 12.63 16.52 11.84C15.73 11.05 14.45 11.05 13.66 11.84Z",
    fill: "#FF43AA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.69 10.11V21.09M5.48 21.09V10.11M22.17 10.58L13.08 5L4 10.58",
    stroke: "#FF43AA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthcareFacilitiesOn);
export default __webpack_public_path__ + "static/media/healthcareFacilitiesOn.91f7eee2f15e30dcb88afd495f9f0da8.svg";
export { ForwardRef as ReactComponent };